// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".gM7jksXXxLGoGzkE9NIs {\r\n  cursor: pointer;\r\n}\r\n.gM7jksXXxLGoGzkE9NIs:hover {\r\n  transform: scale(1.2);\r\n}\r\n", "",{"version":3,"sources":["webpack://./src/components/Auth/Authorization/Authorization.module.css"],"names":[],"mappings":"AAAA;EACE,eAAe;AACjB;AACA;EACE,qBAAqB;AACvB","sourcesContent":[".logOut {\r\n  cursor: pointer;\r\n}\r\n.logOut:hover {\r\n  transform: scale(1.2);\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"logOut": "gM7jksXXxLGoGzkE9NIs"
};
export default ___CSS_LOADER_EXPORT___;
